import React from 'react'
import { Grid, IconButton, useMediaQuery } from '@material-ui/core'
import { DatePicker } from '@material-ui/pickers'
import EventIcon from '@material-ui/icons/Event'
import { FirebaseConfigKey, FirebaseService } from '../../../../services/FirebaseService'
import { MAX_FUTURE_DATE_DAYS } from '../../../../Constants'

export const DatePlanSummary = ({ date, onDateChanged }) => {
  const oldDate = new Date()
  const maxDate = new Date(oldDate.getFullYear(), oldDate.getMonth(), oldDate.getDate() + MAX_FUTURE_DATE_DAYS)
  const isMobile = !useMediaQuery(theme => theme.breakpoints.up('md'))

  const PlanDatePicker = () => (
    <DatePicker
      disablePast
      inputVariant="outlined"
      value={date}
      maxDate={maxDate}
      className="clickable"
      onChange={onDateChanged}
      format={FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)}
      InputProps={{
        disableUnderline: true,
        style: { height: 30, width: 155 },
        endAdornment: (
          <IconButton className="lightgrayblue">
            <EventIcon fontSize={'small'} className="lightgrayblue" />
          </IconButton>
        ),
      }}
    />
  )

  return (
    <>
      {isMobile ? (
        <Grid container justify="space-between" alignItems="center" spacing={3}>
          {/* <Grid item xs={2} >
                        <FlexView hAlignContent={'left'} vAlignContent={'center'}>
                            <DateSectionSvg className='medium-icon' />
                        </FlexView>
                </Grid> */}
          <Grid item>
            <div className="text-body black bolder margin-right-6">Starts on</div>
          </Grid>
          <Grid item>
            <PlanDatePicker />
          </Grid>
        </Grid>
      ) : (
        <Grid container alignItems="center" spacing={3}>
          {/* <Grid item xs={12} md={2}>
                    <FlexView hAlignContent={'center'} vAlignContent={'center'}>
                        <DateSectionSvg className='big-icon' />
                    </FlexView>
                </Grid> */}
          <Grid item xs={12}>
            <Grid container justify="space-between" alignItems="center" alignContent="space-between">
              <Grid item>
                <div className="text-body black bolder margin-right-6">Starts on</div>
              </Grid>
              <Grid item>
                <PlanDatePicker />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  )
}
